import { SATOSPortal } from "@/data-adapter/SATOSPortal";
import { useQuery } from "@tanstack/react-query";

export const useFetchCompanies = () => {
	return useQuery({
		queryKey: [CompanyQueryKeys.companies],
		queryFn: () => SATOSPortal.GetCompanies(),
	});
};

export class CompanyQueryKeys {
	static readonly companies = "companies";
}
